





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AppCardMainLayout extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/layouts/cardlayouts/CardMainLayout/AppCardMainLayout.vue